import { createBundle } from 'widget/Common';
import { routeAuthCodeMap } from 'utils/constants';
// ---- 合同协议 ----
import AgreementsView from 'bundle-loader?lazy&name=AgentContractView!pages/Shop/Member/Agreements/AgreementsView';
import AloneAgreementsView from 'bundle-loader?lazy&name=AloneAgreementsView!pages/Shop/Member/Agreements/aloneAgreements/AloneAgreementsView';
import RegisterNoticeView from 'bundle-loader?lazy&name=RegisterNoticeView!pages/Shop/Member/Agreements/Notice/NoticeView';
import ProductAgreementView from 'bundle-loader?lazy&name=ProductAgreementView!pages/Shop/Member/Agreements/ProductAgreement/ProductAgreementView';
import AgentContractView from 'bundle-loader?lazy&name=AgentContractView!pages/Shop/Member/Agreements/AgentContract/AgentContractView';
import StudioApplyPromiseView from 'bundle-loader?lazy&name=StudioApplyPromiseView!pages/Shop/Member/Agreements/StudioApplyPromise/StudioApplyPromiseView';
import GrantAgentView from 'bundle-loader?lazy&name=GrantAgentView!pages/Shop/Member/Agreements/GrantAgent/GrantAgentView';
import StudioTrainView from 'bundle-loader?lazy&name=StudioTrainView!pages/Shop/Member/Agreements/StudioTrain/StudioTrainView';
import AfterSaleClauseView from 'bundle-loader?lazy&name=AfterSaleClauseView!pages/Shop/Member/Agreements/AfterSaleClause/AfterSaleClauseView';
import TopicAgreementView from 'bundle-loader?lazy&name=TopicAgreementView!pages/Shop/Member/Agreements/TopicAgreement/TopicAgreementView';
import CommonAgreementView from 'bundle-loader?lazy&name=CommonAgreementView!pages/Shop/Member/Agreements/commonAgreement/commonAgreementView';
import ContractSignatureView from 'bundle-loader?lazy&name=ContractSignatureView!pages/Shop/Member/Agreements/ContractSignature';

// ----- 个人中心 模块 -----
import PersonalView from 'bundle-loader?lazy&name=PersonalView!pages/Shop/Member/Personal/PersonalView';
import InvoiceListView from 'bundle-loader?lazy&name=InvoiceListView!biz-micro-services-ui/project/invoice/pages/InvoiceList';
import InvoiceDetailView from 'bundle-loader?lazy&name=InvoiceDetailView!biz-micro-services-ui/project/invoice/pages/InvoiceDetail';
import MsgAddView from 'bundle-loader?lazy&name=MsgAddView!pages/Shop/Member/MsgAdd/MsgAddView';
import MessageView from 'bundle-loader?lazy&name=MessageView!pages/Shop/Member/Personal/Message/MessageView';
import AccountView from 'bundle-loader?lazy&name=AccountView!pages/Shop/Member/Personal/Account/AccountView';
import VirtualPointView from 'bundle-loader?lazy&name=VirtualPointView!pages/Shop/Member/Personal/VirtualPoint/VirtualPointView';
import CloudWarehouseView from 'bundle-loader?lazy&name=CloudWarehouseView!pages/Shop/Member/Personal/CloudWarehouse/CloudWarehouseView';
import THCloudWarehouseView from 'bundle-loader?lazy&name=THCloudWarehouseView!pages/Shop/Member/Personal/THCloudWarehouse/THCloudWarehouseView';
import ServiceCodeView from 'bundle-loader?lazy&name=ServiceCodeView!pages/Shop/Member/Personal/ServiceCode/ServiceCodeView';
import EvaluateView from 'bundle-loader?lazy&name=EvaluateView!pages/Shop/Member/Personal/ServiceCode/Evaluate/EvaluateView';
import ServiceDetailsView from 'bundle-loader?lazy&name=ServiceDetailsView!pages/Shop/Member/Personal/ServiceCode/ServiceDetails/ServiceDetailsView';
import ServiceStoreView from 'bundle-loader?lazy&name=ServiceStoreView!pages/Shop/Member/Personal/ServiceCode/ServiceStore/ServiceStoreView';
import ServiceStoreDetailsView from 'bundle-loader?lazy&name=ServiceStoreDetailsView!pages/Shop/Member/Personal/ServiceCode/ServiceStoreDetails/ServiceStoreDetailsView';
import ChangeStoreView from 'bundle-loader?lazy&name=VirtualPointView!pages/Shop/Member/Personal/ChangeStore/ChangeStoreView';
import SupplementaryCardView from 'bundle-loader?lazy&name=SupplementaryCardView!pages/Shop/Member/Personal/SupplementaryCard/SupplementaryCardView';
import PeptideMilkAnnualPassView from 'bundle-loader?lazy&name=PeptideMilkAnnualPassView!pages/Shop/Member/Personal/PeptideMilkAnnualPass/PeptideMilkAnnualPassView';
import BindView from 'bundle-loader?lazy&name=BindView!pages/Shop/Member/Personal/Account/Bind/BindView';
import BindWechatView from 'bundle-loader?lazy&name=BindWechatView!pages/Shop/Member/Personal/Account/BindWechat/BindWechatView';
import PhoneVerifyView from 'bundle-loader?lazy&name=PhoneVerifyView!pages/Shop/Member/Personal/Account/PhoneVerify/PhoneVerifyView';
import AlterPasswordView from 'bundle-loader?lazy&name=AlterPasswordView!pages/Shop/Member/Personal/Account/AlterPassword/AlterPasswordView';
import AddressListView from 'bundle-loader?lazy&name=AddressListView!pages/Shop/Member/Address/AddressList/AddressListView';
import AddressDetailsView from 'bundle-loader?lazy&name=AddressDetailsView!pages/Shop/Member/Address/AddressDetails/AddressDetailsView';
import NewAddressView from 'bundle-loader?lazy&name=NewAddressView!pages/Shop/Member/Address/NewAddress/NewAddressView';
import MyCollectView from 'bundle-loader?lazy&name=MyCollectView!pages/Shop/Member/Personal/MyCollect/MyCollectView';
import NoviceCourseListView from 'bundle-loader?lazy&name=NoviceCourseListView!pages/Shop/Member/Personal/NoviceCourse/NoviceCourseList/NoviceCourseListView';
import NoviceCourseDetailView from 'bundle-loader?lazy&name=NoviceCourseDetailView!pages/Shop/Member/Personal/NoviceCourse/NoviceCourseDetail/NoviceCourseDetailView';
import GlanceOverView from 'bundle-loader?lazy&name=GlanceOverView!pages/Shop/Member/Personal/GlanceOver/GlanceOverView';
import SicknessView from 'bundle-loader?lazy&name=SicknessView!pages/Shop/Member/Personal/Sickness/SicknessView';
import OtherSicknessView from 'bundle-loader?lazy&name=OtherSicknessView!pages/Shop/Member/Personal/Sickness/Other/OtherView';
import ProtectionView from 'bundle-loader?lazy&name=ProtectionView!pages/Shop/Member/Personal/Protection/ProtectionView';
import CertificatesView from 'bundle-loader?lazy&name=ProtectionView!pages/Shop/Member/Personal/Certificates/CertificatesView';
import YofouiDemoView from 'bundle-loader?lazy&name=YofouiDemoView!pages/Shop/Member/Personal/YofouiDemo/YofouiDemoView';
import CommonDemoPage from 'bundle-loader?lazy&name=CommonDemoPage!pages/Shop/Member/Personal/CommonDemoPage';
import UploadCertificatesView from 'bundle-loader?lazy&name=UploadCertificatesView!pages/Shop/Member/Personal/Certificates/Upload/UploadView';
import MyArchivesView from 'bundle-loader?lazy&name=MyArchivesView!pages/Shop/Member/Personal/Account/MyArchives/MyArchivesView';
import InviteRegisterView from 'bundle-loader?lazy&name=MyArchivesView!pages/Shop/Member/Personal/InviteRegister/InviteRegisterView';
import ProfitSharingView from 'bundle-loader?lazy&name=MyArchivesView!pages/Shop/Member/Personal/ProfitSharing/ProfitSharingView';
import ProfitSharBindView from 'bundle-loader?lazy&name=MyArchivesView!pages/Shop/Member/Personal/ProfitSharing/ProfitSharBind/ProfitSharBindView';
import MyEvaluateView from 'bundle-loader?lazy&name=MyEvaluateView!biz-micro-services-ui/project/evaluate/pages/myEvaluate';
import QuestionnaireView from 'bundle-loader?lazy&name=Questionnaire!pages/Shop/Member/Questionnaire/QuestionnaireView';
import CompleteView from 'bundle-loader?lazy&name=Questionnaire!pages/Shop/Member/Questionnaire/CompleteView';
import GiftWarehouseView from 'bundle-loader?lazy&name=GiftWarehouseView!pages/Shop/Member/Personal/GiftWarehouse/GiftWarehouseView';
import GiftWarehouseShareGiftView from 'bundle-loader?lazy&name=GiftWarehouseShareGiftView!pages/Shop/Member/Personal/GiftWarehouse/ShareGift/ShareGiftView';
import ShareGiftListView from 'bundle-loader?lazy&name=ShareGiftListView!pages/Shop/Member/Personal/GiftWarehouse/ShareGiftList/ShareGiftListView';
import ReceiveListView from 'bundle-loader?lazy&name=ReceiveListView!pages/Shop/Member/Personal/GiftWarehouse/ReceiveList/ReceiveListView';
import SelectMallHomeView from 'bundle-loader?lazy&name=SelectMallHomeView!pages/Shop/Member/Personal/SelectMall/SelectMallHome/SelectMallHomeView'; //甄选商城首页
import SelectMallCartView from 'bundle-loader?lazy&name=SelectMallCartView!pages/Shop/Member/Personal/SelectMall/SelectMallCart/SelectMallCartView'; //甄选商城购物车
import SelectMallCoinListView from 'bundle-loader?lazy&name=SelectMallCoinListView!pages/Shop/Member/Personal/SelectMall/SelectMallCoinList/SelectMallCoinListView'; //甄选商城积分列表
import IntegralWalletView from 'bundle-loader?lazy&name=IntegralWalletView!pages/Shop/Member/Wallet/IntegralWallet/indexView';
import IntegralWalletTransferView from 'bundle-loader?lazy&name=IntegralWalletTransferView!pages/Shop/Member/Wallet/IntegralTransfer/TransferView';
import GuidePageView from 'bundle-loader?lazy&name=MyArchivesView!pages/Shop/Member/Personal/GuidePage/GuidePageView';
import XBLWarehouseView from 'bundle-loader?lazy&name=XBLWarehouseView!pages/Shop/Member/Personal/XBLWarehouse/XBLWarehouseView';
import OnlineExamView from 'bundle-loader?lazy&name=OnlineExamView!biz-micro-services-ui/project/middlePlatform/pages/onlineExam';

// ----- 交易管理 模块 -----
import OrderListView from 'bundle-loader?lazy&name=OrderListView!pages/Shop/Member/TradeManage/OrderList/OrderListView';
import NewOrderEvaluateView from 'bundle-loader?lazy&name=OrderEvaluateView!pages/Shop/Member/TradeManage/OrderEvaluate/NewOrderEvaluate';
import GroupBuyListView from 'bundle-loader?lazy&name=GroupBuyListView!pages/Shop/Member/TradeManage/OrderList/GroupBuy/GroupBuyList/GroupBuyListView';
import OrderDetailView from 'bundle-loader?lazy&name=OrderDetailView!pages/Shop/Member/TradeManage/OrderList/Detail/DetailView';
import OrderSearchView from 'bundle-loader?lazy&name=OrderSearchView!pages/Shop/Member/TradeManage/OrderList/Search/SearchView';
import GroupBuyShareView from 'bundle-loader?lazy&name=GroupBuyShareView!pages/Shop/Member/TradeManage/OrderList/GroupBuy/GroupBuyShare/GroupBuyShareView';
import DeliveryListView from 'bundle-loader?lazy&name=DeliveryListView!pages/Shop/Member/TradeManage/OrderList/Detail/DeliveryList/DeliveryListView';
import DeliveryView from 'bundle-loader?lazy&name=DeliveryView!pages/Shop/Member/TradeManage/OrderList/Detail/Delivery/DeliveryView';
import LogisticsView from 'bundle-loader?lazy&name=LogisticsView!pages/Shop/Member/TradeManage/OrderList/Detail/Logistics/LogisticsView';
import LYLogisticsView from 'bundle-loader?lazy&name=LYLogisticsView!pages/Shop/Member/TradeManage/OrderList/Detail/LYLogistics/LYLogisticsView';
import DeliveryTmpView from 'bundle-loader?lazy&name=DeliveryTmpView!pages/Shop/Member/TradeManage/OrderList/Detail/DeliveryTmp/DeliveryTmpView';
import OldLogisticsView from 'bundle-loader?lazy&name=OldLogisticsView!pages/Shop/Member/TradeManage/OrderList/Detail/OldLogistics/OldLogisticsView';
import QuickBuyView from 'bundle-loader?lazy&name=QuickBuyView!pages/Shop/Member/TradeManage/QuickBuy/QuickBuyView';
import QuickBuyForCouponView from 'bundle-loader?lazy&name=QuickBuyForCouponView!pages/Shop/Member/TradeManage/QuickBuyForCoupon/QuickBuyView';
import AlterAddressView from 'bundle-loader?lazy&name=AlterAddressView!pages/Shop/Member/TradeManage/OrderList/AlterAddress/AlterAddressView';
import OrderSwitchView from 'bundle-loader?lazy&name=OrderSwitchView!pages/Shop/Member/TradeManage/OrderSwitch/OrderSwitchView';
import SwitchView from 'bundle-loader?lazy&name=SwitchView!pages/Shop/Member/TradeManage/OrderSwitch/Switch/SwitchView';
import LogisticsListView from 'bundle-loader?lazy&name=LogisticsListView!pages/Shop/Member/TradeManage/OrderList/LogisticsList/LogisticsListView';
import QuickProductListView from 'bundle-loader?lazy&name=QuickProductListView!pages/Shop/Member/TradeManage/quickProductList/QuickProductListView';
import QuickBuySwiperView from 'bundle-loader?lazy&name=QuickBuySwiperView!pages/Shop/Member/TradeManage/QuickBuySwiper/QuickBuySwiperView';
import QuickBuyEventZoneView from 'bundle-loader?lazy&name=QuickBuyEventZoneView!pages/Shop/Member/TradeManage/QuickBuy/EventZone/EventZoneView';

// ----- 售后 模块 -----
import AfterSaleListView from 'bundle-loader?lazy&name=AfterSaleListView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleList/AfterSaleListView';
import ApplyAfterSaleView from 'bundle-loader?lazy&name=ApplyAfterSaleView!pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ApplyAfterSaleView';
import AfterSaleSelectOrdersView from 'bundle-loader?lazy&name=AfterSaleSelectOrdersView!pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/SelectOrders/SelectOrdersView';
import AfterSaleSelectProductsView from 'bundle-loader?lazy&name=AfterSaleSelectProductsView!pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/SelectProducts/SelectProductsView';
import AfterSaleSubmitView from 'bundle-loader?lazy&name=AfterSaleSubmitView!pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/Submit/SubmitView';
import AfterSaleDetailView from 'bundle-loader?lazy&name=AfterSaleDetailView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/AfterSaleDetailView';
import AfterSaleApplyDetailView from 'bundle-loader?lazy&name=AfterSaleApplyDetailView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/ApplyDetail/ApplyDetailView';
import AfterSaleSendBackView from 'bundle-loader?lazy&name=AfterSaleSendBackView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/SendBack';
import AfterSaleDetailProgressView from 'bundle-loader?lazy&name=AfterSaleDetailProgressView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/Progress/ProgressView';
import AfterSaleDetailOrderInfoView from 'bundle-loader?lazy&name=AfterSaleDetailOrderInfoView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/OrderInfo/OrderInfoView';
import AfterSaleDetailCostListView from 'bundle-loader?lazy&name=AfterSaleDetailCostListView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/CostList/CostListView';
import LogisticsInfoView from 'bundle-loader?lazy&name=LogisticsInfoView!pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/LogisticsInfo/LogisticsInfoView';
import ReplaceGoodsView from 'bundle-loader?lazy&name=ReplaceGoodsView!pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ReplaceGoods/ReplaceGoodsView';

// ----- 钱包 模块 -----
import NomalWalletView from 'bundle-loader?lazy&name=NomalWalletView!pages/Shop/Member/Wallet/NomalWallet/NomalWalletView';
import CisternWalletView from 'bundle-loader?lazy&name=CisternWalletView!pages/Shop/Member/Wallet/CisternWallet/CisternWalletView';
import BonusWalletView from 'bundle-loader?lazy&name=BonusWalletView!pages/Shop/Member/Wallet/BonusWallet/BonusWalletView';
import BoutiqueWalletView from 'bundle-loader?lazy&name=BonusWalletView!pages/Shop/Member/Wallet/BoutiqueWallet/BoutiqueWalletView';
import InterWalletView from 'bundle-loader?lazy&name=BonusWalletView!pages/Shop/Member/Wallet/InterWallet/InterWalletView';
import LianchuangWalletView from 'bundle-loader?lazy&name=LianchuangWalletView!pages/Shop/Member/Wallet/LianchuangWallet/indexView';

import ScoreView from 'bundle-loader?lazy&name=ScoreView!pages/Shop/Member/Wallet/Score/ScoreView';
import CoinView from 'bundle-loader?lazy&name=CoinView!pages/Shop/Member/Wallet/Coin/CoinView';
import LifeCouponFenNiaoView from 'bundle-loader?lazy&name=LifeCouponFenNiaoView!pages/Shop/Member/Wallet/LifeCouponFenNiao/indexView';
import ChangeLifeCouponView from 'bundle-loader?lazy&name=ChangeLifeCouponView!pages/Shop/Member/Wallet/ChangeLifeCoupon/indexView';

import PayPwdView from 'bundle-loader?lazy&name=PayPwdView!pages/Shop/Member/Wallet/PayPwd/PayPwdView';
import SecurityVerifyView from 'bundle-loader?lazy&name=SecurityVerifyView!pages/Shop/Member/Wallet/PayPwd/SecurityVerify/SecurityVerifyView';
import SetPayPwdView from 'bundle-loader?lazy&name=SetPayPwdView!pages/Shop/Member/Wallet/PayPwd/SetPayPwd/SetPayPwdView';
import TransactionListView from 'bundle-loader?lazy&name=TransactionListView!pages/Shop/Member/Wallet/TransactionList/TransactionListView';
import TransactionDetailView from 'bundle-loader?lazy&name=TransactionDetailView!pages/Shop/Member/Wallet/TransactionDetail/TransactionDetailView';
import BankCardView from 'bundle-loader?lazy&name=BankCardView!pages/Shop/Member/Wallet/BankCard/BankCardView';
import OpenEcardView from 'bundle-loader?lazy&name=OpenEcardView!pages/Shop/Member/Wallet/BankCard/OpenEcard/indexView';
import BankCardVerifyView from 'bundle-loader?lazy&name=BankCardVerifyView!pages/Shop/Member/Wallet/BankCard/Verify/VerifyView';
import BankCardModifyView from 'bundle-loader?lazy&name=BankCardModifyView!pages/Shop/Member/Wallet/BankCard/BankCardModify/BankCardModifyView';
import BillListView from 'bundle-loader?lazy&name=BillListView!pages/Shop/Member/Wallet/Bill/BillList/BillListView';
import BillDetailView from 'bundle-loader?lazy&name=BillDetailView!pages/Shop/Member/Wallet/Bill/BillDetail/BillDetailView';
import RechargeView from 'bundle-loader?lazy&name=RechargeView!pages/Shop/Member/Wallet/Recharge/RechargeView';
import RefundView from 'bundle-loader?lazy&name=RefundView!pages/Shop/Member/Wallet/Refund/RefundView';
import RefundDetailView from 'bundle-loader?lazy&name=RefundDetailView!pages/Shop/Member/Wallet/Refund/RefundDetail/RefundDetailView';
import RechargeListView from 'bundle-loader?lazy&name=RechargeListView!pages/Shop/Member/Wallet/Refund/RechargeList/RechargeListView';
import RefundApplyView from 'bundle-loader?lazy&name=RefundApplyView!pages/Shop/Member/Wallet/Refund/RefundApply/RefundApplyView';
import TransferView from 'bundle-loader?lazy&name=TransferView!pages/Shop/Member/Wallet/Transfer/TransferView';
import WithDrawListView from 'bundle-loader?lazy&name=WithDrawListView!pages/Shop/Member/Wallet/WithDraw/WithDrawList/WithDrawListView';
import WithDrawApplyView from 'bundle-loader?lazy&name=WithDrawApplyView!pages/Shop/Member/Wallet/WithDraw/WithDrawApply/WithDrawApplyView';
import WithDrawApplyUploadView from 'bundle-loader?lazy&name=WithDrawApplyUploadView!pages/Shop/Member/Wallet/WithDraw/WithDrawApply/UploadPics/UploadPicsView';
import CouponView from 'bundle-loader?lazy&name=CouponView!pages/Shop/Member/Wallet/Coupon/CouponView';
import TakeDeliveryList from 'bundle-loader?lazy&name=TakeDeliveryList!pages/Shop/Member/Wallet/Coupon/TakeDeliveryList/TakeDeliveryListView';
import CouponRecordView from 'bundle-loader?lazy&name=CouponRecordView!pages/Shop/Member/Wallet/Coupon/Record/RecordView';
import CouponCartView from 'bundle-loader?lazy&name=CouponCartView!pages/Shop/Member/Wallet/Coupon/CouponCart/index';
import UseCouponView from 'bundle-loader?lazy&name=CouponRecordView!pages/Shop/Member/Wallet/Coupon/Products/ProductsView';
import CouponTransferView from 'bundle-loader?lazy&name=CouponTransferView!pages/Shop/Member/Wallet/Coupon/CouponTransfer/CouponTransferView';
import TransferFindView from 'bundle-loader?lazy&name=TransferFindView!pages/Shop/Member/Wallet/Coupon/TransferFind/TransferFindView';
import CouponVerificationView from 'bundle-loader?lazy&name=CouponVerificationView!pages/Shop/Member/Wallet/Coupon/CouponVerification/index';
import BankSearchView from 'bundle-loader?lazy&name=BankSearchView!pages/Register/BankSearch/BankSearchView';
import UsageDetailsView from 'bundle-loader?lazy&name=UsageDetailsView!pages/Shop/Member/Wallet/Coupon/UsageDetails/UsageDetailsView';

// ----- 新客注册 模块 -----
import AgentRegisterView from 'bundle-loader?lazy&name=AgentRegisterView!pages/Shop/Member/Personal/AgentRegister/AgentRegisterView';
import ShareAppView from 'bundle-loader?lazy&name=ShareAppView!pages/Shop/Member/ShareApp/ShareAppView';

// ------- end -------
//生日月
import BirthdayLive from 'bundle-loader?lazy&name=ShareAppView!pages/Share/birthdayLive/birthdayLiveView';
//webview
import WebView from 'bundle-loader?lazy&name=ShareAppView!pages/Shop/Member/WebView/index';
//Metaverse
import Metaverse from 'bundle-loader?lazy&name=ShareAppView!pages/Shop/Member/Metaverse/index';
// 助梦计划
import DreamPlanView from 'bundle-loader?lazy&name=DreamPlanView!biz-micro-services-ui/project/middlePlatform/pages/dreamPlan/home';

// 我的橱窗
import ShowCaseView from 'bundle-loader?lazy&name=ShowCaseView!biz-micro-services-ui/project/middlePlatform/pages/dreamPlan/showCase';
// 添加橱窗
import ShowCaseAddView from 'bundle-loader?lazy&name=ShowCaseAddView!biz-micro-services-ui/project/middlePlatform/pages/dreamPlan/showCase/addShowCase';
// XX的橱窗
import DreamPlanShoppingView from 'bundle-loader?lazy&name=DreamPlanShoppingView!biz-micro-services-ui/project/middlePlatform/pages/dreamPlan/shopping';

// 云连锁
import CloudChainView from 'bundle-loader?lazy&name=CloudChainView!pages/Shop/Member/Personal/CloudChain/CloudChainView';
import CloudChainBusinessLicense from 'bundle-loader?lazy&name=CloudChainBusinessLicense!pages/Shop/Member/Personal/CloudChain/CloudChainBusinessLicense';
import CloudChainStoreInfo from 'bundle-loader?lazy&name=CloudChainStoreInfo!pages/Shop/Member/Personal/CloudChain/CloudChainStoreInfo';
// import CloudChainAauditResult from 'bundle-loader?lazy&name=CloudChainAauditResult!biz-micro-services-ui/project/middlePlatform/pages/cloudChainAauditResult/index';
import CloudChainAauditResult from 'bundle-loader?lazy&name=CloudChainAauditResult!pages/Shop/Member/Personal/CloudChain/CloudChainAauditResult';

const RouterConfig = [
  // ---- 合同协议 ----
  {
    path: '/agreements/protection/:code',
    title: '权益保护',
    component: () => {
      return createBundle(AgreementsView);
    }
  },
  {
    path: '/agreements/aloneAgreements/alone',
    title: '代理经销商合同',
    component: () => {
      return createBundle(AloneAgreementsView);
    }
  },
  {
    path: '/agreements/notice',
    title: '注册须知',
    component: () => {
      return createBundle(RegisterNoticeView);
    }
  },
  {
    path: '/agreements/product',
    title: '生命银行协议',
    component: () => {
      return createBundle(ProductAgreementView);
    }
  },
  {
    path: '/agreements/agentContract',
    title: '代理经销商合同',
    component: () => {
      return createBundle(AgentContractView);
    }
  },
  {
    path: '/agreements/studioApplyPromise',
    title: '健康顾问工作室申请人承诺书',
    component: () => {
      return createBundle(StudioApplyPromiseView);
    }
  },
  {
    path: '/agreements/grantAgentView',
    title: '授权经销协议',
    component: () => {
      return createBundle(GrantAgentView);
    }
  },
  {
    path: '/agreements/studioTrainView',
    title: '健康顾问工作室培训条例',
    component: () => {
      return createBundle(StudioTrainView);
    }
  },
  {
    path: '/agreements/commonAgreementView',
    title: '店铺合同详情',
    component: () => {
      return createBundle(CommonAgreementView);
    }
  },
  {
    path: '/agreements/AfterSaleClauseView',
    title: '售后条款',
    component: () => {
      return createBundle(AfterSaleClauseView);
    }
  },
  {
    path: '/agreements/topicAgreement',
    title: '专题合同',
    component: () => {
      return createBundle(TopicAgreementView);
    }
  },
  {
    path: '/agreements/contractSignature',
    title: '合同签名',
    component: () => {
      return createBundle(ContractSignatureView);
    }
  },
  // ----- 个人中心 -----
  {
    path: '/personal',
    title: '我的',
    component: () => {
      return createBundle(PersonalView);
    }
  },
  {
    path: '/personal/invoiceList',
    title: '我的发票',
    component: () => {
      return createBundle(InvoiceListView);
    }
  },
  {
    path: '/personal/invoiceDetail',
    title: '发票详情',
    component: () => {
      return createBundle(InvoiceDetailView);
    }
  },
  {
    path: '/personal/msgAdd',
    title: '补充资料',
    component: () => {
      return createBundle(MsgAddView);
    }
  },
  {
    path: '/personal/QuestionnaireView',
    title: '问卷调查',
    component: () => {
      return createBundle(QuestionnaireView);
    }
  },
  {
    path: '/personal/CompleteView',
    title: '问卷调查结果',
    component: () => {
      return createBundle(CompleteView);
    }
  },
  {
    path: '/personal/message',
    title: '我的消息',
    component: () => {
      return createBundle(MessageView);
    }
  },
  {
    path: '/personal/account',
    title: '我的账户',
    component: () => {
      return createBundle(AccountView);
    }
  },
  {
    path: '/personal/VirtualPoint',
    title: '虚拟资格',
    component: () => {
      return createBundle(VirtualPointView);
    }
  },
  {
    path: '/personal/cloudWarehouse',
    title: '我的云仓',
    component: () => {
      return createBundle(CloudWarehouseView);
    }
  },
  {
    path: '/personal/thCloudWarehouse',
    title: '我的云仓',
    component: () => {
      return createBundle(THCloudWarehouseView);
    }
  },
  {
    path: '/personal/serviceCode',
    title: '服务码',
    component: () => {
      return createBundle(ServiceCodeView);
    }
  },
  {
    path: '/personal/evaluate',
    title: '发表评价',
    component: () => {
      return createBundle(EvaluateView);
    }
  },
  {
    path: '/personal/serviceDetails',
    title: '服务详情',
    component: () => {
      return createBundle(ServiceDetailsView);
    }
  },
  {
    path: '/personal/serviceStore',
    title: '服务门店',
    component: () => {
      return createBundle(ServiceStoreView);
    }
  },
  {
    path: '/personal/serviceStoreDetails',
    title: '门店详情',
    component: () => {
      return createBundle(ServiceStoreDetailsView);
    }
  },
  {
    path: '/personal/ChangeStore',
    title: '更新工作室',
    component: () => {
      return createBundle(ChangeStoreView);
    }
  },
  {
    path: '/personal/SupplementaryCard',
    title: '权益共享卡',
    component: () => {
      return createBundle(SupplementaryCardView);
    }
  },
  {
    path: '/personal/PeptideMilkAnnualPass',
    title: '肽素乳畅享卡',
    component: () => {
      return createBundle(PeptideMilkAnnualPassView);
    }
  },
  {
    path: '/personal/account/AlterPassword',
    title: '修改密码',
    component: () => {
      return createBundle(AlterPasswordView);
    }
  },
  {
    path: '/personal/account/bind/:operation',
    title: '帐号绑定',
    component: () => {
      return createBundle(BindView);
    }
  },
  {
    path: '/personal/account/bindWechat',
    title: '绑定微信账号',
    component: () => {
      return createBundle(BindWechatView);
    }
  },
  {
    path: '/personal/account/phoneVerify',
    title: '安全验证',
    component: () => {
      return createBundle(PhoneVerifyView);
    }
  },
  {
    path: '/personal/certificates',
    title: '我的证件',
    component: () => {
      return createBundle(CertificatesView);
    }
  },
  {
    path: '/personal/certificates/upload/:type',
    title: '上传证件',
    component: () => {
      return createBundle(UploadCertificatesView);
    }
  },
  {
    path: '/personal/myArchives',
    title: '我的档案',
    component: () => {
      return createBundle(MyArchivesView);
    }
  },
  {
    path: '/personal/sickness',
    title: '既往病史',
    component: () => {
      return createBundle(SicknessView);
    }
  },
  {
    path: '/personal/sickness/other',
    title: '既往病史',
    component: () => {
      return createBundle(OtherSicknessView);
    }
  },
  {
    path: '/personal/protection',
    title: '消费者权益',
    component: () => {
      return createBundle(ProtectionView);
    }
  },
  {
    path: '/personal/yofouiDemo',
    title: '组件示例',
    component: () => {
      return createBundle(YofouiDemoView);
    }
  },
  {
    path: '/personal/commonDemo',
    title: 'Demo预览页',
    component: () => {
      return createBundle(CommonDemoPage);
    }
  },
  {
    path: '/personal/invite',
    // title: '邀请开卡',
    title: '邀请升级',
    component: () => {
      return createBundle(InviteRegisterView);
    }
  },
  {
    path: '/personal/profitSharing',
    title: '合利共盈',
    component: () => {
      return createBundle(ProfitSharingView);
    }
  },
  {
    path: '/personal/shareApp',
    title: '分享APP',
    component: () => {
      return createBundle(ShareAppView);
    }
  },
  {
    path: '/personal/profitSharBind',
    title: '申请绑定',
    component: () => {
      return createBundle(ProfitSharBindView);
    }
  },
  {
    path: '/personal/guide',
    // title: '邀请开卡',
    title: '',
    component: () => {
      return createBundle(GuidePageView);
    }
  }, // GuidePageView

  {
    path: '/member/addressList',
    title: '地址管理',
    component: () => {
      return createBundle(AddressListView);
    }
  },
  {
    path: '/member/addressDetails',
    title: '查看地址',
    component: () => {
      return createBundle(AddressDetailsView);
    }
  },
  {
    path: '/member/newAddress',
    title: '新建/编辑地址',
    component: () => {
      return createBundle(NewAddressView);
    }
  },
  {
    path: '/member/myCollect',
    title: '我的收藏',
    component: () => {
      return createBundle(MyCollectView);
    }
  },
  {
    path: '/personal/noviceCourseList',
    title: '新手教程',
    component: () => {
      return createBundle(NoviceCourseListView);
    }
  },
  {
    path: '/personal/noviceCourseDetail',
    title: '新手教程视频',
    component: () => {
      return createBundle(NoviceCourseDetailView);
    }
  },
  {
    path: '/personal/GlanceOverView',
    title: '浏览足迹',
    component: () => {
      return createBundle(GlanceOverView);
    }
  },
  {
    path: '/personal/GiftWarehouse/ShareGiftView',
    title: '分享礼品',
    component: () => {
      return createBundle(GiftWarehouseShareGiftView);
    }
  },
  {
    path: '/personal/GiftWarehouseView',
    title: '我的礼品仓',
    component: () => {
      return createBundle(GiftWarehouseView);
    }
  },
  {
    path: '/personal/shareGiftList',
    title: '我的礼品',
    component: () => {
      return createBundle(ShareGiftListView);
    }
  },
  {
    path: '/personal/receiveGiftList',
    title: '物流记录',
    component: () => {
      return createBundle(ReceiveListView);
    }
  },
  {
    path: '/personal/SelectMallHomeView',
    title: '甄选商城首页',
    component: () => {
      return createBundle(SelectMallHomeView);
    }
  },
  {
    path: '/personal/SelectMallCartView',
    title: '甄选商城购物车',
    component: () => {
      return createBundle(SelectMallCartView);
    }
  },
  {
    path: '/personal/SelectMallCoinList',
    title: '甄选商城购物车',
    component: () => {
      return createBundle(SelectMallCoinListView);
    }
  },
  {
    path: '/personal/SelectMallWalletView',
    title: '甄选积分',
    component: () => {
      return createBundle(IntegralWalletView);
    }
  },
  {
    path: '/personal/SelectMall/transferView',
    title: '积分转账',
    component: () => {
      return createBundle(IntegralWalletTransferView);
    }
  },
  // ----- 交易管理 -----
  {
    path: '/member/order',
    title: '我的订单',
    component: () => {
      return createBundle(OrderListView);
    }
  },
  {
    path: '/member/order/OrderEvaluateView',
    title: '评价',
    component: () => {
      return createBundle(NewOrderEvaluateView);
    }
  },
  {
    path: '/member/MyEvaluateView',
    title: '我的评价',
    authCode: routeAuthCodeMap.EVALUATION_SWITCH,
    component: () => {
      return createBundle(MyEvaluateView);
    }
  },
  {
    path: '/member/groupBuyOrder',
    title: '我的拼团',
    component: () => {
      return createBundle(GroupBuyListView);
    }
  },
  {
    path: '/member/order/detail/:tradeNo',
    title: '订单详情',
    component: () => {
      return createBundle(OrderDetailView);
    }
  },
  {
    path: '/member/order/groupBuyShare/:groupId/:tradeNo/:activityId/:itemId',
    title: '拼团分享页',
    component: () => {
      return createBundle(GroupBuyShareView);
    }
  },
  {
    path: '/member/order/alterAddress/:tradeNo',
    title: '修改地址',
    component: () => {
      return createBundle(AlterAddressView);
    }
  },
  {
    path: '/member/order/search',
    title: '搜索订单',
    component: () => {
      return createBundle(OrderSearchView);
    }
  },
  {
    path: '/member/order/deliveryList/:tradeNo',
    title: '发货信息',
    component: () => {
      return createBundle(DeliveryListView);
    }
  },
  {
    path: '/member/order/delivery',
    title: '发货明细',
    component: () => {
      return createBundle(DeliveryView);
    }
  },

  {
    path: '/member/order/logistics',
    title: '物流信息',
    component: () => {
      return createBundle(LogisticsView);
    }
  },
  {
    path: '/member/order/lyLogistics',
    title: '物流信息',
    component: () => {
      return createBundle(LYLogisticsView);
    }
  },
  {
    path: '/member/order/logisticsTmp/:tradeNo',
    title: '物流信息中间页',
    component: () => {
      return createBundle(DeliveryTmpView);
    }
  },
  {
    path: '/member/order/oldLogistics/:tradeNo/:deliveryNo',
    title: '物流信息',
    component: () => {
      return createBundle(OldLogisticsView);
    }
  },
  {
    path: '/member/quickBuy',
    title: '快速购物',
    component: () => {
      return createBundle(QuickBuyView);
    }
  },
  {
    path: '/shop/QuickProductList',
    title: '产品目录',
    component: () => {
      return createBundle(QuickProductListView);
    }
  },
  {
    path: '/member/quickBuyForCoupon',
    title: '快速购物优惠劵',
    component: () => {
      return createBundle(QuickBuyForCouponView);
    }
  },
  {
    path: '/member/quickBuyEventZoneView',
    title: '享考察活动专区',
    component: () => {
      return createBundle(QuickBuyEventZoneView);
    }
  },
  {
    path: '/member/quickBuySwiperView',
    title: '快速购物轮播展示',
    component: () => {
      return createBundle(QuickBuySwiperView);
    }
  },
  {
    path: '/member/orderSwitch',
    title: '订单调期',
    component: () => {
      return createBundle(OrderSwitchView);
    }
  },
  {
    path: '/member/orderSwitch/switch',
    title: '订单调期',
    component: () => {
      return createBundle(SwitchView);
    }
  },
  {
    path: '/member/order/logisticsList',
    title: '物流信息',
    component: () => {
      return createBundle(LogisticsListView);
    }
  },
  // ----- 售后 -----
  {
    path: '/member/afterSale/list',
    title: '售后记录',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleListView);
    }
  },
  {
    path: '/member/afterSale/apply',
    title: '申请售后',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(ApplyAfterSaleView);
    }
  },
  {
    path: '/member/afterSale/apply/selectOrders',
    title: '选择订单',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleSelectOrdersView);
    }
  },
  {
    path: '/member/afterSale/apply/selectProducts',
    title: '选择商品',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleSelectProductsView);
    }
  },
  {
    path: '/member/afterSale/apply/replace',
    title: '更换商品',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(ReplaceGoodsView);
    }
  },
  {
    path: '/member/afterSale/apply/submit',
    title: '售后说明',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleSubmitView);
    }
  },
  {
    path: '/member/afterSale/detail',
    title: '售后详情',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleDetailView);
    }
  },
  {
    path: '/member/afterSale/detail/applyDetail',
    title: '售后申请详情',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleApplyDetailView);
    }
  },
  {
    path: '/member/afterSale/detail/sendBack',
    title: '寄回物流信息',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleSendBackView);
    }
  },
  {
    path: '/member/afterSale/detail/progress',
    title: '进度记录',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleDetailProgressView);
    }
  },
  {
    path: '/member/afterSale/detail/orderInfo',
    title: '订单信息',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleDetailOrderInfoView);
    }
  },
  {
    path: '/member/afterSale/detail/costList',
    title: '费用清单',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(AfterSaleDetailCostListView);
    }
  },
  {
    path: '/member/afterSale/detail/logisticsInfo',
    title: '物流信息',
    authCode: routeAuthCodeMap.PERSONAL_AFTER_SALE,
    component: () => {
      return createBundle(LogisticsInfoView);
    }
  },
  // ----- 钱包 -----
  {
    path: '/member/NomalWallet',
    title: '充值钱包',
    component: () => {
      return createBundle(NomalWalletView);
    }
  },
  {
    path: '/member/CisternWallet',
    title: '换购钱包',
    component: () => {
      return createBundle(CisternWalletView);
    }
  },
  {
    path: '/member/BonusWallet',
    title: '分享钱包',
    component: () => {
      return createBundle(BonusWalletView);
    }
  },
  {
    path: '/member/BoutiqueWallet',
    title: '精选钱包',
    component: () => {
      return createBundle(BoutiqueWalletView);
    }
  },
  {
    path: '/member/InterWallet',
    title: '国际钱包',
    component: () => {
      return createBundle(InterWalletView);
    }
  },
  {
    path: '/member/LianchuangWallet',
    title: '联创钱包',
    component: () => {
      return createBundle(LianchuangWalletView);
    }
  },
  {
    path: '/member/Score',
    title: '蜂鸟积分',
    component: () => {
      return createBundle(ScoreView);
    }
  },
  {
    path: '/member/Coin',
    title: '兑换积分',
    component: () => {
      return createBundle(CoinView);
    }
  },
  {
    path: '/member/LifeCouponFenNiao',
    title: '我的生活券',
    component: () => {
      return createBundle(LifeCouponFenNiaoView);
    }
  },
  {
    path: '/member/ChangeLifeCoupon',
    title: '兑换生活券',
    component: () => {
      return createBundle(ChangeLifeCouponView);
    }
  },
  {
    path: '/member/wallet/payPwd',
    title: '支付管理',
    component: () => {
      return createBundle(PayPwdView);
    }
  },
  {
    path: '/member/wallet/payPwd/securityVerify',
    title: '安全认证',
    component: () => {
      return createBundle(SecurityVerifyView);
    }
  },
  {
    path: '/member/wallet/payPwd/setPayPwd',
    title: '设置支付密码',
    component: () => {
      return createBundle(SetPayPwdView);
    }
  },
  {
    path: '/member/wallet/transactionList',
    title: '交易明细',
    component: () => {
      return createBundle(TransactionListView);
    }
  },
  {
    path: '/member/wallet/transactionDetail',
    title: '交易明细详情',
    component: () => {
      return createBundle(TransactionDetailView);
    }
  },
  {
    path: '/member/wallet/bankCard',
    title: '银行卡',
    component: () => {
      return createBundle(BankCardView);
    }
  },
  {
    path: '/member/wallet/bankCard/openEcard',
    title: '开通E钱包',
    component: () => {
      return createBundle(OpenEcardView);
    }
  },
  {
    path: '/member/wallet/bankCard/verify',
    title: '银行卡安全认证',
    component: () => {
      return createBundle(BankCardVerifyView);
    }
  },
  {
    path: '/member/wallet/bankCard/modify',
    title: '银行卡修改',
    component: () => {
      return createBundle(BankCardModifyView);
    }
  },
  {
    path: '/member/wallet/bankCard/bankSearch',
    title: '支行搜索',
    component: () => {
      return createBundle(BankSearchView);
    }
  },
  {
    path: '/member/wallet/bill/list',
    title: '历史账单',
    component: () => {
      return createBundle(BillListView);
    }
  },
  {
    path: '/member/wallet/bill/detail',
    title: '账单详情',
    component: () => {
      return createBundle(BillDetailView);
    }
  },
  {
    path: '/member/wallet/recharge',
    title: '充值',
    component: () => {
      return createBundle(RechargeView);
    }
  },
  {
    path: '/member/wallet/transfer',
    title: '转账',
    component: () => {
      return createBundle(TransferView);
    }
  },
  {
    path: '/member/wallet/withDraw/list',
    title: '提现申请',
    component: () => {
      return createBundle(WithDrawListView);
    }
  },
  {
    path: '/member/wallet/withDraw/apply',
    title: '提现申请',
    component: () => {
      return createBundle(WithDrawApplyView);
    }
  },
  {
    path: '/member/wallet/withDraw/apply/upload',
    title: '提现申请',
    component: () => {
      return createBundle(WithDrawApplyUploadView);
    }
  },
  {
    path: '/member/wallet/refund',
    title: '退款',
    component: () => {
      return createBundle(RefundView);
    }
  },
  {
    path: '/member/wallet/refund/detail/:id',
    title: '交易详情',
    component: () => {
      return createBundle(RefundDetailView);
    }
  },
  {
    path: '/member/wallet/refund/rechargeList',
    title: '充值交易明细',
    component: () => {
      return createBundle(RechargeListView);
    }
  },
  {
    path: '/member/wallet/refund/apply',
    title: '充值退款申请',
    component: () => {
      return createBundle(RefundApplyView);
    }
  },
  {
    path: '/member/wallet/coupon',
    title: '优惠券',
    component: () => {
      return createBundle(CouponView);
    }
  },
  {
    path: '/member/wallet/coupon/TakeDeliveryList',
    title: '提货券使用列表',
    component: () => {
      return createBundle(TakeDeliveryList);
    }
  },
  {
    path: '/member/wallet/coupon/record',
    title: '使用记录',
    component: () => {
      return createBundle(CouponRecordView);
    }
  },
  {
    path: '/member/wallet/coupon/cart',
    title: '优惠券购物车',
    component: () => {
      return createBundle(CouponCartView);
    }
  },
  {
    path: '/member/wallet/coupon/use/:id',
    title: '使用优惠券',
    component: () => {
      return createBundle(UseCouponView);
    }
  },
  {
    path: '/member/wallet/coupon/transfer/:id',
    title: '转让优惠券',
    component: () => {
      return createBundle(CouponTransferView);
    }
  },
  {
    path: '/member/wallet/coupon/transfer/find/:id/:code/:count',
    title: '查找受让人',
    component: () => {
      return createBundle(TransferFindView);
    }
  },
  {
    path: '/member/wallet/coupon/verification',
    title: '核销券',
    component: () => {
      return createBundle(CouponVerificationView);
    }
  },
  {
    path: '/member/agentRegister',
    title: '代客注册',
    component: () => {
      return createBundle(AgentRegisterView);
    }
  },
  {
    path: '/birthday/Live',
    title: '生日直播',
    component: () => {
      return createBundle(BirthdayLive);
    }
  },
  {
    path: '/WebView/index',
    title: '',
    component: () => {
      return createBundle(WebView);
    }
  },
  {
    path: '/Metaverse/index',
    title: '',
    component: () => {
      return createBundle(Metaverse);
    }
  },
  {
    path: '/personal/XBLWarehouseView',
    title: '',
    component: () => {
      return createBundle(XBLWarehouseView);
    }
  },
  {
    path: '/personal/OnlineExam',
    title: '',
    component: () => {
      return createBundle(OnlineExamView);
    }
  },
  {
    path: '/cloudChainBasicInformation',
    title: '云连锁基础报名信息',
    component: () => {
      return createBundle(CloudChainView);
    }
  },
  {
    path: '/cloudChainBusinessLicense',
    title: '云连锁营业执照信息',
    component: () => {
      return createBundle(CloudChainBusinessLicense);
    }
  },
  {
    path: '/cloudChainStoreInfo',
    title: '云连锁店铺经营信息',
    component: () => {
      return createBundle(CloudChainStoreInfo);
    }
  },
  {
    path: '/cloudChainAauditResult',
    title: '云连锁审核结果',
    component: () => {
      return createBundle(CloudChainAauditResult);
    }
  },
  {
    path: '/personal/dreamPlan',
    title: '',
    component: () => {
      return createBundle(DreamPlanView);
    }
  },
  {
    path: '/personal/showCase',
    title: '',
    component: () => {
      return createBundle(ShowCaseView);
    }
  },
  {
    path: '/personal/showCaseAdd',
    title: '',
    component: () => {
      return createBundle(ShowCaseAddView);
    }
  },
  {
    path: '/personal/dreamPlanShopping',
    title: '',
    component: () => {
      return createBundle(DreamPlanShoppingView);
    }
  },
  {
    path: '/member/wallet/coupon/usageDetails',
    title: '使用明细',
    component: () => {
      return createBundle(UsageDetailsView);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/RouterConfig.js